import React from 'react';
import { BetReceiptShell } from '../keno/BetReceiptShell';
import { PublicReceiptFairness } from '../keno/PublicReceiptFairness';
import { OriginalVerifyForm } from './OriginalVerifyForm';
import { MinesBoard } from './MinesBoard';
import { DiceReceipt } from './DiceReceipt';
import { PlinkoReceipt } from './PlinkoReceipt';
import './game.css';
import { formatLimboResult } from './limboDisplay';

export const OriginalBetDetails = ({ round, game, onClose, onCloseAutoFocus, onPlay }) => <BetReceiptShell round={round} type={round.game} playerGhost={game?.wallet?.ghost} onClose={onClose} onCloseAutoFocus={onCloseAutoFocus} onPlay={onPlay}
  shareable={round.public_view || !game?.demo}
  fairness={round.public_view ? <PublicReceiptFairness round={round} /> : <OriginalVerifyForm game={{ ...game, gameType: round.game, round }} />}>
  {round.game === 'plinko' ? <PlinkoReceipt round={round} /> : round.game === 'mines' ? <MinesBoard game={{ round }} receipt prefix="mines-receipt" /> : round.game === 'dice' ? <DiceReceipt round={round} /> : <div className="limbo-receipt-results">
    <div><span>Target</span><strong data-testid="limbo-receipt-target">{(round.params.target_e8 / 1e8).toFixed(2)}×</strong></div>
    <div><span>Result</span><strong className={round.win ? 'is-positive' : 'is-negative'} data-testid="limbo-receipt-result">{formatLimboResult(round.outcome.crash_e8)}×</strong></div>
  </div>}
</BetReceiptShell>;